import { constants } from "@newsela/angelou";

const { colors } = constants;

export const textCss = {
  color: colors.ui.core[700],
  marginTop: "1px",
  borderRadius: "0px 0px 4px 4px",
};

export const answerCss = {
  padding: "6px 16px",
  width: "100%",
  backgroundColor: colors.ui.neutral[25],
};
